const trackPlayEvent = (dataLayer = {}, productSeries = "", playCount = 0) => {
  dataLayer.push({
    event: "Interactive Video Engagement",
    eventAction: `Play ${productSeries} Interactive Video`,
    eventDetail: playCount
  });
};

const trackStartCardCTA = (dataLayer = {}) => {
  dataLayer.push({
    event: "Interactive Video Engagement",
    eventAction: "In Store CTA Click: Explore a new era of clean",
  });
};

const trackReplayClick = (dataLayer = {}, productSeries = "") => {
  dataLayer.push({
    event: "Interactive Video Engagement",
    eventAction: `Replay Video ${productSeries}`,
  });
};

const trackSizzleStart = (dataLayer = {}, productSeries = "") => {
  dataLayer.push({
    event: "Interactive Video Engagement",
    eventAction: `Play ${productSeries} Sizzle Video`,
  });
};

const trackSizzleEnd = (dataLayer = {}, productSeries = "") => {
  dataLayer.push({
    event: "Interactive Video Engagement",
    eventAction: `Complete ${productSeries} Sizzle Video`,
  });
};

const trackStageReach = (
  dataLayer = {},
  stageNumber = "",
  stageName = "",
  reachMethod = ""
) => {
  dataLayer.push({
    event: "Interactive Video Engagement",
    eventAction: `${reachMethod}`,
    eventLabel: `${stageNumber}: ${stageName}`,
  });
};

const trackPortraitAlert = (dataLayer = {}) => {
  dataLayer.push({
    event: "Interactive Video Engagement",
    eventAction: "Portrait mode alert impression",
  });
};

const trackVideoPause = (
  dataLayer = {},
  productSeries = "",
  playedInterval = ""
) => {
  dataLayer.push({
    event: "Interactive Video Engagement",
    eventAction: `Pause ${productSeries} Interactive Video`,
    eventLabel: playedInterval,
  });
};

const trackVideoEnd = (
  dataLayer = {},
  productSeries = "",
  playedInterval = ""
) => {
  dataLayer.push({
    event: "Interactive Video Engagement",
    eventAction: `Complete ${productSeries} Interactive Video`,
    eventLabel: playedInterval,
  });
};

export const onVideoEnd = (
  dataLayer = {},
  productSeries = "",
  playedTime = ""
) => {
  try {
    trackVideoEnd(dataLayer, productSeries, playedTime);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn("GA onVideoEnd", error);
  }
};

export const onVideoPause = (
  dataLayer = {},
  productSeries = "",
  playedTime = ""
) => {
  try {
    trackVideoPause(dataLayer, productSeries, playedTime);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn("GA onVideoPause", error);
  }
};

export const onPortrait = (dataLayer = {}) => {
  try {
    trackPortraitAlert(dataLayer);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log("onPortrait", error);
  }
};

export const onNavBtnClick = (
  dataLayer = {},
  stageNumber,
  stageName,
  reachMethod = "Click"
) => {
  try {
    trackStageReach(dataLayer, stageNumber, stageName, reachMethod);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log("GA onNavBtnClick", error);
  }
};

export const onStageViewthrough = (
  dataLayer = {},
  stageNumber,
  stageName,
  reachMethod = "Viewthrough"
) => {
  try {
    trackStageReach(dataLayer, stageNumber, stageName, reachMethod);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log("GA onStageViewthrough", error);
  }
};

export const onSizzleStart = (dataLayer = {}, productSeries = "") => {
  try {
    trackSizzleStart(dataLayer, productSeries);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn("GA onSizzleStart: ", error.toString());
  }
};

export const onSizzleEnd = (dataLayer = {}, productSeries = "") => {
  try {
    trackSizzleEnd(dataLayer, productSeries);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn("GA onSizzleEnd: ", error.toString());
  }
};

export const onPlayClick = (dataLayer = {}, productSeries = "", playCount = 0) => {
  try {
    trackPlayEvent(dataLayer, productSeries, playCount);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn("GA onPlayClick: ", error.toString());
  }
};

export const onStartCardCTAClick = (dataLayer = {}) => {
  try {
    trackStartCardCTA(dataLayer);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn("GA onStartCardCTAClick: ", error.toString());
  }
};

export const onReplayClick = (dataLayer = {}, productSeries = "") => {
  try {
    trackReplayClick(dataLayer, productSeries);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn("GA onReplayClick: ", error.toString());
  }
};

export default {
  onPlayClick,
  onStartCardCTAClick,
  onReplayClick,
  onSizzleStart,
  onSizzleEnd,
  onNavBtnClick,
  onStageViewthrough,
  onPortrait,
  onVideoPause,
  onVideoEnd,
};
